import { createStore } from 'satcheljs';

export interface CalendarAgendaViewStore {
    isAgendaViewShown: boolean;
    selectedCalendarEventId: string | null;
}

const calendarAgendaViewStore: CalendarAgendaViewStore = {
    isAgendaViewShown: true,
    selectedCalendarEventId: null,
};

export const getCalendarAgendaViewStore = createStore<CalendarAgendaViewStore>(
    'calendarAgendaViewStore',
    calendarAgendaViewStore
);
